import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Organism } from '@/core/architecture'

export const ResaleItemBoxSkeleton: Organism = () => (
  <Card elevation={0}>
    <CardContent sx={{ p: 5, '&:last-child': { pb: 5 } }}>
      <Stack direction="row" spacing={2}>
        <Stack flex={1} sx={{ pt: 1 }}>
          <SkeletonText variant="medium" width="25%" />
          <SkeletonText variant="medium" width="50%" />
          <Stack direction="row" spacing={3}>
            <Stack flex={1}>
              <SkeletonText variant="small" />
              <SkeletonText variant="small" />
              <SkeletonText variant="small" />
            </Stack>
            <Stack flex={3}>
              <SkeletonText variant="small" />
              <SkeletonText variant="small" />
              <SkeletonText variant="small" />
            </Stack>
          </Stack>
        </Stack>
        <Skeleton variant="rectangular" width={72} height={121} />
      </Stack>
    </CardContent>
  </Card>
)
